import { Component } from '@angular/core';

@Component({
    selector: 'rule',
    templateUrl: './rule.component.html',
    styleUrls: ['./_text.component.scss']
})
export class RuleComponent {
}


// WEBPACK FOOTER //
// D:/programming/Чижик_Api_Site_Sources-Electroline/front/src/app/pages/rule.component.ts